import { utm } from '../../utils/utm';
import { initCustomerIO } from '../../utils/customer-io';

document.addEventListener('alpine:init', () => {
  Alpine.data('flowForm', () => ({
    blockID: '',
    customBlockID: 'acf/flow-form',
    formData: {},
    data: { fields: [] },
    countries: [],
    tabs: [],
    activeTab: 0,
    changes: 0,
    disabled: false,
    recaptchaValue: '',
    success: false,
    entryLimit: 0,
    mfqId: '',
    customerIoFormId: '',
    addToCalendarScriptInitialized: false,

    init() {
      window._mfq = window._mfq || [];
      this.mfqId = this.$root.dataset.mfqId;
      this.customerIoFormId = this.$root.dataset.customerIoFormId;

      this.blockID = this.$root.dataset.id;

      if (utm) {
        Object.keys(utm).forEach((p) => {
          if (utm[p]) {
            const utmInput = document.createElement('input');
            utmInput.hidden = true;
            utmInput.name = p === 'gclid' ? p : `utm_${p}`;
            utmInput.setAttribute('value', utm[p]);
            this.$refs.form.append(utmInput);

            if (p === 'gclid') {
              this.formData[p] = utm[p];
            } else {
              this.formData[`utm_${p}`] = utm[p];
            }
          }
        });
      }

      if (this.mfqId) {
        _mfq.push([
          'config',
          'forms',
          [
            {
              formPath: location.pathname,
              target: {
                selector: '.ff-success-message',
              },
              result: 'success',
            },
          ],
        ]);
      }

      if (this.customerIoFormId) {
        initCustomerIO();
      }

      this.$nextTick(() => this.ready());
    },

    ready() {
      // Resolve custom block ID
      document.querySelectorAll('.flow-form').forEach((input, i) => {
        if (input === this.$root) {
          this.customBlockID += `|${i}`;
        }
      });

      this.entryLimit = +this.$root.dataset.entryLimit;

      if (this.entryLimit || this.$root.dataset.cioEvent === 'true') {
        fetch(
          `${window.ajaxurl}?action=flow_entry_count&post_id=${this.$root.dataset.postId}&block_id=${this.customBlockID}`,
          { method: 'GET' }
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.success) {
              if (
                (this.entryLimit && +response.data.entry_count < this.entryLimit) ||
                !response.data.cio_limit_reached
              ) {
                this.initForm();
              } else {
                this.success = true;
                this.$refs.form.innerHTML = `<div>${response.data.message}</div>`;
              }
            }
          })
          .catch((error) => console.error(error));
      } else {
        this.initForm();
      }
    },

    initForm() {
      this.data = JSON.parse(this.$refs.data.innerHTML);

      this.countries = JSON.parse(this.$refs.countries.innerHTML)
        .split(/\r?\n/)
        .filter((line) => line.trim())
        .map((line) => line.split(' : '))
        .map(([value, label]) => ({
          value: value === 'no_select' ? '' : value,
          label: label ?? value,
          disabled: value === 'no_select',
        }));
      this.formatChoices(this.countries);

      if (window.location.pathname.startsWith('/zh-hans/')) {
        const chinaIndex = this.countries.findIndex((country) => country.value === 'China');
        const china = this.countries[chinaIndex];

        this.countries.splice(chinaIndex, 1);
        this.countries.splice(1, 0, china);
      }

      let tab = -1;

      if (this.data.fields.length > 0 && this.data.fields[0].acf_fc_layout !== 'tab') {
        tab = 0;
        this.tabs.push({
          label: 'Form',
          logic: '',
        });
      }

      for (const field of this.data.fields) {
        field.tab = tab;

        if (field.acf_fc_layout === 'text_input') {
          this.formData[field.name] = '';
        } else if (field.acf_fc_layout === 'select' || field.acf_fc_layout === 'radio_group') {
          this.formData[field.name] = field.default;
        } else if (field.acf_fc_layout === 'checkbox') {
          this.formData[field.name] = field.checked;
        } else if (field.acf_fc_layout === 'text') {
          field.text = field.text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        } else if (field.acf_fc_layout === 'tab') {
          tab++;
          this.tabs.push(field);
        }

        if (field.choices === 'countries') {
          field.choices = this.countries;
        } else if (field.choices) {
          field.choices = field.choices
            .split(/\r?\n/)
            .filter((line) => line.trim())
            .map((line) => line.split(' : '))
            .map(([value, label]) => ({
              value: value === 'no_select' ? '' : value,
              label: label ?? value,
              disabled: value === 'no_select',
            }));

          this.formatChoices(field.choices);
        }
      }

      if (this.$root.dataset.recaptcha) {
        grecaptcha.ready(() => {
          this.refreshRecaptcha();
          setInterval(() => this.refreshRecaptcha(), 60000);
        });
      }
    },

    formatChoices(choices) {
      choices.forEach((choice) => {
        choice.value = choice.value.replace(/&amp;/g, '&');
        choice.label = choice.label.replace(/&amp;/g, '&');
      });
    },

    onSubmit() {
      let valid = true;

      if (this.mfqId) {
        window._mfq.push(['formSubmitAttempt', this.mfqId]);
      }

      if (this.customerIoFormId && window.analytics) {
        analytics.track('formSubmitAttempt', {
          formId: this.customerIoFormId,
          url: window.location.href,
        });
      }

      for (const field of this.data.fields) {
        if (field.tab === this.activeTab && field.validation?.length > 0) {
          const logic = field.logic
            .trim()
            .replace(/form\./g, 'this.formData.')
            .replace(/&amp;/g, '&');

          if (!logic || new Function(`return ${logic}`).call(this)) {
            for (const validation of field.validation) {
              if (new RegExp(validation.regexp.replaceAll('§', '\\')).test(String(this.formData[field.name]))) {
                field.error = null;
              } else {
                field.error = validation.message;
                valid = false;
              }
            }

            if (
              valid &&
              field.email_blacklist &&
              field.email_blacklist
                .split('\n')
                .map((d) => d.trim())
                .some((d) => this.formData[field.name].includes(d))
            ) {
              field.error = field.email_blacklist_error;
            }
          }
        }
      }

      if (valid) {
        if (this.activeTab < this.tabs.length - 1) {
          this.activeTab++;
          setTimeout(() => this.scrollToTop());
        } else if (!this.disabled) {
          this.disabled = true;

          const body = new FormData();

          body.append('action', 'submit_flow');
          body.append('block_id', this.customBlockID);
          body.append('post_id', this.$root.dataset.postId);

          if (this.recaptchaValue) {
            body.append('recaptcha', this.recaptchaValue);
          }

          for (const name in this.formData) {
            body.append(name, this.formData[name]);
          }

          fetch(window.ajaxurl, { method: 'POST', body })
            .then((response) => response.json())
            .then((response) => {
              if (response.success) {
                this.success = true;
                this.$refs.form.innerHTML =
                  '<div class="ff-success-message">' +
                  response.data.success_message.replace('[calendar-invite-buttons]', this.createInviteButtons()) +
                  '</div>';
                this.$refs.form.classList.add('sales-form-success');
                setTimeout(() => this.scrollToTop());

                if (this.mfqId) {
                  window._mfq.push(['formSubmitSuccess', this.mfqId]);
                }

                if (this.customerIoFormId && window.analytics) {
                  if (body.get('email')) {
                    analytics.identify(body.get('email'));
                  }

                  analytics.track('formSubmitSuccess', {
                    formId: this.customerIoFormId,
                    url: window.location.href,
                  });
                }

                try {
                  if (this.data.jsOnSuccess?.trim()) {
                    new Function('formData', this.data.jsOnSuccess)(body);
                  }
                } catch (e) {
                  console.error(e);
                }

                this.$refs.form.dispatchEvent(new CustomEvent('form-success'));
              } else if (response.data?.errors) {
                for (const [name, error] of Object.entries(response.data.errors)) {
                  const field = this.data.fields.find((field) => field.name === name);

                  if (field) {
                    field.error = error;
                  }

                  if (this.mfqId) {
                    window._mfq.push(['formSubmitFailure', this.mfqId]);
                  }

                  if (this.customerIoFormId && window.analytics) {
                    analytics.track('formSubmitFailure', {
                      formId: this.customerIoFormId,
                      url: window.location.href,
                    });
                  }
                }
              }
            })
            .catch((error) => {
              console.error(error);

              if (this.mfqId) {
                window._mfq.push(['formSubmitFailure', this.mfqId]);
              }

              if (this.customerIoFormId && window.analytics) {
                analytics.track('formSubmitFailure', {
                  formId: this.customerIoFormId,
                  url: window.location.href,
                });
              }
            })
            .finally(() => {
              this.disabled = false;

              if (!this.success) {
                this.refreshRecaptcha();
              }
            });
        }
      } else {
        setTimeout(() =>
          this.$root.querySelector('.error-text:not([hidden])')?.parentElement.scrollIntoView({ behavior: 'smooth' })
        );
      }
    },

    onClickTab(index) {
      if (index < this.activeTab) {
        this.activeTab = index;
      } else if (index > this.activeTab) {
        this.onSubmit();
      }
    },

    refreshRecaptcha() {
      if (!this.disabled) {
        grecaptcha
          .execute(this.$root.dataset.recaptcha, {
            action: 'homepage',
          })
          .then((token) => {
            this.recaptchaValue = token;
          });
      }
    },

    scrollToTop() {
      this.$refs.form.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    },

    tabEl: {
      ':disabled'() {
        if (this.i > this.activeTab + 1) {
          return true;
        }

        const logic = this.tab.logic
          .trim()
          .replace(/form\./g, 'this.formData.')
          .replace(/&amp;/g, '&');

        if (!logic) {
          return false;
        }

        return this.changes > -1 && !new Function(`return ${logic}`).call(this);
      },
    },

    fieldEl: {
      ':class'() {
        return {
          'flow-form__field--half': this.field.width === 'half',
        };
      },
      ':hidden'() {
        if (this.field.acf_fc_layout === 'tab') {
          return true;
        }

        const logic = this.field.logic
          ?.trim()
          .replace(/form\./g, 'this.formData.')
          .replace(/&amp;/g, '&');

        if (!logic) {
          return false;
        }

        return this.changes > -1 && !new Function(`return ${logic}`).call(this);
      },
    },

    inputEl: {
      ':class'() {
        return {
          dirty: this.formData[this.field.name],
        };
      },
      '@change'() {
        this.changes++;
      },
    },

    createInviteButtons() {
      if (!this.addToCalendarScriptInitialized) {
        this.addToCalendarScriptInitialized = true;

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@2';
        script.async = true;
        script.defer = true;

        document.head.appendChild(script);
      }

      if (this.data.add_calendar_invite) {
        return this.data.calendar_invite_script.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      }

      return '';
    },
  }));
});